import React, { useEffect, useCallback, useState} from 'react';
import Colors from 'components/Colors.js';
import SampleStreamOption from './SampleStreamOption.js';
import {connect} from 'react-redux';

const colors = new Colors();

const SamplesStreamTag = ({stream, tag, samples, track, onClickTag, loadingSample, scrollRef, id}) => { 
    let [expanded, setExpanded] = useState(false);

    useEffect(() => {
        setExpanded(false);
    }, [stream, setExpanded]);

    const onMouseDown = useCallback(() => {
        if (expanded) {
            stream.tagSounds = samples.map(x => x.getId());
        }
    }, [expanded, stream, samples]);

    return (
        <div onMouseDown={onMouseDown} className="samples-stream-tag">
          <div onClick={() => setExpanded(!expanded)} className={expanded ? "tag-info expanded" : "tag-info"}>
            <div style={{
                borderRightColor: colors.getColorForHash(tag),
                borderLeftColor: colors.getColorForHash(tag),
            }} className="tag-box"/> {tag}
          </div>
          <div className="tag-results">
          {expanded &&
           samples.map(
               (sample, i) =>
                   <SampleStreamOption
                     scrollRef={scrollRef}
                     onClickTag={onClickTag}
                     loadingSample={loadingSample}
                     tags={track.samplesStream.tags}
                     track={track}
                     selected={id === sample.getId()}
                     key={sample.getId() + '-' + i}
                     sample={sample}
                     id={sample.getId()}/>)}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SamplesStreamTag);
